import type { MailboxInfo } from 'owa-client-types';
import getDefaultRoamingTimezones from './getDefaultRoamingTimezones';

export default function hasMultipleTimezonesConfigured(mailboxInfo: MailboxInfo): boolean {
    return getDefaultRoamingTimezones(mailboxInfo).length > 0;
}
